/**
 * loại chứng từ
 */
export default {
    /* -----------------------------------------------------
    Cấu hình RefType cho biên lai
     ------------------------------------------------------ */
    // Phiếu thu
    CashReceipt: 20,
    
    // Phiếu nộp tiền vào tài khoản
    Deposit: 41,
    
    // Phiếu kết chuyển tài khoản 
    AccountTransferSlipVoucher: 70,
   
    // Chứng từ nghiệp vụ khác
    GeneralJournalEntry: 80,
    
  };
  